import type { ReactNode } from 'react'
import { useId } from 'react'
import { cx } from '@dorixona/ui'

export interface FieldProps {
  label: string
  /** Подпись «необязательно» рядом с названием поля. */
  optional?: string
  /**
   * Звёздочка у обязательного поля. Диктору она не нужна (aria-hidden): об
   * обязательности он узнаёт от самого контрола через aria-required.
   */
  required?: boolean
  hint?: string
  error?: string
  children: (props: { id: string; describedBy: string | undefined }) => ReactNode
}

/**
 * Поле формы: подпись, контрол, подсказка или ошибка. Ошибка ЗАМЕНЯЕТ подсказку —
 * два текста под полем читаются как спор друг с другом.
 */
export function Field({ label, optional, required, hint, error, children }: FieldProps) {
  const id = useId()
  const messageId = `${id}-message`
  const message = error ?? hint

  return (
    <div className={cx('field', error && 'field--invalid')}>
      <label htmlFor={id}>
        {label}
        {required ? (
          <span className="reqmark" aria-hidden="true">
            {' *'}
          </span>
        ) : null}
        {optional ? <span className="optlbl"> — {optional}</span> : null}
      </label>
      {children({ id, describedBy: message ? messageId : undefined })}
      {message ? (
        <p className="fhint" id={messageId} role={error ? 'alert' : undefined}>
          {message}
        </p>
      ) : null}
    </div>
  )
}
